export default __webpack_public_path__ + "assets/images/d4008091cbf29873ba0464dbdf6d9671.svg";